import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import NavbarSection from "../Navbar/NavbarSection";

export default function LogoLayout() {
  if (localStorage.getItem("admin_token")) {
    return <Navigate to={"/dashboard"}></Navigate>;
  }
  return (
    <>
      <div>
        <NavbarSection />
      </div>
      <Outlet />
    </>
  );
}
